import { Type } from "@angular/core";
import { CmsData } from "@dotcom-frontend/data";

export class DynamicComponentItem {
  constructor(
    public component: Type<any>,
    public data: CmsData | undefined
  ) {}
}
